<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c3.48,0,5.22,1.74,5.22,1.74v3.97l-5.22-3.26l-5.22,3.26v-3.97C-4.72,784.24-2.98,782.5,0.5,782.5L0.5,782.5z
	 M5.72,790.26v1.43l-5.22-3.26l-5.22,3.26v-1.43L0.5,787L5.72,790.26z M5.72,793.74v1.43l-5.22-3.26l-5.22,3.26v-1.43l5.22-3.26
	L5.72,793.74z M5.72,797.22v0.06L0.5,802.5l-5.22-5.22v-0.06l5.22-3.26L5.72,797.22z"/>
</svg>

</template>